import * as ko from 'knockout'
import Clarity from '@microsoft/clarity'
import { observable } from 'knockout-decorators'
import '../utils/ko-extenders'

import { Graphics } from '../utils/graphics'

import '../styles/bootstrap.scss'
import './page.less'

import '../components/page-alert/page-alert'
import '../components/page-footer/page-footer'
import '../components/page-header/page-header'
import { PaymentPrechecker } from '../components/payment-checker/payment-prechecker'
import { ErrorReporter } from '../utils/error-reporting'

import '@fontsource/nunito/variable.css'

import ArrowUpCircleIcon from '../images/icons/heroicons/arrow-up-circle.svg?url'

const isProduction = import.meta.env.MODE === 'production'
const clarityId = 'y3oxadjp2b'

export abstract class Page {
  @observable public robotsMeta = isProduction
    ? 'index, follow'
    : 'noindex, nofollow'

  @observable public showBackToTop = false
  public arrowUpCircleIcon = ArrowUpCircleIcon

  public showBackToTopButton: ko.Observable<boolean> | ko.Computed<boolean> =
    ko.observable(true)

  private scrollThreshold = 400

  constructor() {
    Graphics.init()
    ErrorReporter.init()
    if (isProduction) {
      Clarity.init(clarityId)
    }

    this.addMetaTag()
    this.initBackToTop()

    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.injectBackToTop()
        ko.applyBindings(this)
        ko.applyBindings(this, document.head)
      }
    }

    window.addEventListener('load', async () => {
      await PaymentPrechecker.check()
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          for (const registration of registrations) {
            registration.unregister()
          }
        })
      }
    })
  }

  private addMetaTag() {
    let metaTag = document.querySelector('meta[name="robots"]')

    if (!metaTag) {
      metaTag = document.createElement('meta')
      metaTag.setAttribute('name', 'robots')
      document.head.appendChild(metaTag)
    }

    ko.applyBindingsToNode(
      metaTag,
      { attr: { content: this.robotsMeta } },
      this
    )
  }

  private injectBackToTop() {
    const app = document.getElementById('app')
    if (!app) return
    const wrapper = document.createElement('div')
    wrapper.innerHTML = `
      <div data-bind="visible: showBackToTopButton">
        <button id="back-to-top" data-bind="click: scrollToTop, css: { visible: showBackToTop }" aria-label="Back to top">
          <img data-bind="attr: { src: arrowUpCircleIcon }" alt="" />
        </button>
      </div>
    `
    app.appendChild(wrapper.firstElementChild!)
  }

  private initBackToTop() {
    window.addEventListener('scroll', () => {
      this.showBackToTop = window.scrollY > this.scrollThreshold
    })
  }

  public scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
}
